import './SectionHeading.css';

/**
 * Заголовок раздела с описанием.
 *
 * @param {object} props
 * @param {string} props.title
 * @param {string} [props.description]
 */
function SectionHeading({ title, description }) {
  return (
    <div className="section-heading">
      <div className="section-heading__main">
        <h2 className="section-heading__title">{title}</h2>
        {description && <p className="section-heading__desc">{description}</p>}
      </div>
    </div>
  );
}

export default SectionHeading;
